export const MODULE_LIST = {
  getModuleList: {
    url: '/v1/admin/master-modules',
    method: 'GET',
  },
};
